import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import Loading from "../../../../Extra/Loading";
import {
  getCurrentFY,
  getDaysBetweenMonths,
  getDaysInMonth,
  getFinancialYearMonthsPassed,
} from "../../../../Utilitie";
import CrackMonthlyReportGraph from "../../../Others/Crack/GraphView/CrackMonthlyReportGraph";
const months = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];

const PuncMonthlyReport = () => {
  const [data, setData] = useState([]);
  const [fyYears, setFyYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const tableRef = useRef();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;
  const currentYear = new Date().getFullYear();
  const defaultFy = `${currentYear}-${currentYear + 1}`;
  const [selectedFy, setSelectedFy] = useState(defaultFy);
  const mpassed = getFinancialYearMonthsPassed(getCurrentFY(), false);
  const [selectedMonths, setSelectedMonths] = useState([...mpassed]);

  const result = [
    ...Object.values(
      data.reduce((acc, item) => {
        const { group_type, fyYears, month_name, month_no, SUM_RPT } = item;

        if (!acc[group_type]) {
          acc[group_type] = {
            group_type,
            children: [],
          };
        }

        let fyObj = acc[group_type].children.find((c) => c.fyYears === fyYears);

        if (!fyObj) {
          fyObj = {
            fyYears,
            data: [],
          };

          acc[group_type].children.push(fyObj);
        }

        fyObj.data.push({
          month_name,
          month_no,
          total_no: SUM_RPT,
        });

        return acc;
      }, {}),
    ),

    {
      fyYears: [...new Set(data.map((item) => item.fyYears))],
    },
  ];
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}get_icms_report02_summary?FyYear=${selectedFy}`,
        );

        if (response.status === "ok") {
          setData(response.data.data);
          setFyYears(response.data.fyYears);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);
  const sections = result.filter((item) => item.children);

  const sortedSections = [...sections].sort((a, b) => {
    const getPrevTotal = (section) => {
      const prevData = section.children[0]?.data || [];
      const prevMap = {};

      prevData.forEach((item) => {
        prevMap[item.month_name] = Number(item.total_no) || 0;
      });
      return selectedMonths.reduce((sum, m) => sum + (prevMap[m] || 0), 0);
    };

    return getPrevTotal(b) - getPrevTotal(a);
  });

  return (
    <div>
      <h5 className="bg-dark text-white p-2">Punctuality Month Wise Report</h5>

      <div className="d-flex newUiBody align-items-center gap-3 flex-wrap p-2">
        <select
          className="form-select text-black fw-bolder text-center form-control w-25"
          onChange={(e) => {
            setSelectedFy(e.target.value);
          }}
          value={selectedFy}
        >
          {fyYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div
        className="d-flex newUiBody flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 p-3  border rounded shadow-sm"
        style={{ background: "rgba(240, 240, 240, 0.48)" }}
      >
        <div className="d-flex flex-wrap align-items-center gap-2">
          <label className="fw-bold me-2 mb-0">Filter by Months:</label>
          {months.map((month) => {
            const isActive = selectedMonths.includes(month);
            return (
              <span
                key={month}
                className={`badge rounded-pill px-3 py-2 ${
                  isActive ? "bg-primary text-white" : "bg-secondary text-white"
                }`}
                onClick={() =>
                  setSelectedMonths((prev) =>
                    prev.includes(month)
                      ? prev.filter((m) => m !== month)
                      : [...prev, month],
                  )
                }
                style={{ userSelect: "none", cursor: "pointer" }}
              >
                {month}
              </span>
            );
          })}
        </div>

        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => setSelectedMonths([...months])}
          >
            Select All
          </button>
          <button
            className="btn btn-sm btn-outline-dark"
            onClick={() => setSelectedMonths([])}
          >
            Deselect All
          </button>
        </div>
      </div>

      <div
        className="table-wrapper table-responsive"
        style={{ maxHeight: "500px", overflowY: "auto" }}
      >
        {loading && <Loading />}

        <table
          ref={tableRef}
          border="1"
          cellPadding="8"
          className="table  table-hover table-striped table-bordered"
          style={{ fontSize: "13px" }}
        >
          <thead className="table-dark text-center sticky-top">
            <tr>
              <th rowSpan={2} className="align-middle">
                Group Type
              </th>
              <th colSpan={selectedMonths.length}>
                Previous Year ({selectedFy.replace(/\d+/g, (y) => +y - 1)})
              </th>
              {selectedMonths.length > 0 && (
                <th rowSpan={2} className="align-middle">
                  Total
                </th>
              )}
              {
                <th rowSpan={2} className="align-middle">
                  AVG
                </th>
              }
              <th colSpan={selectedMonths.length}>
                Current Year ({selectedFy})
              </th>
              {selectedMonths.length > 0 && (
                <th rowSpan={2} className="align-middle">
                  Total
                </th>
              )}
              {
                <th rowSpan={2} className="align-middle">
                  AVG
                </th>
              }

              <th colSpan={selectedMonths.length}>Variation Percentage</th>
              {selectedMonths.length > 0 && (
                <th rowSpan={2} className="align-middle">
                  V/P Total
                </th>
              )}
            </tr>
            <tr>
              {selectedMonths.map((m) => (
                <th key={`head-prev-${m}`}>{m}</th>
              ))}
              {selectedMonths.map((m) => (
                <th key={`head-curr-${m}`}>{m}</th>
              ))}

              {selectedMonths.map((m) => (
                <th key={`head-var-${m}`}>{m} %</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {sortedSections.map((section, i) => {
              const prevYearData = {};
              const currYearData = {};

              const prevData = section.children[0]?.data || [];
              const currData = section.children[1]?.data || [];

              prevData.forEach((item) => {
                prevYearData[item.month_name] = Number(item.total_no) || 0;
              });

              currData.forEach((item) => {
                currYearData[item.month_name] = Number(item.total_no) || 0;
              });
              let prevTotal = 0;
              let currTotal = 0;

              let prevCount = 0;
              let currCount = 0;

              selectedMonths.forEach((m) => {
                const prevVal = prevYearData[m] || 0;
                const currVal = currYearData[m] || 0;

                prevTotal += prevVal;
                currTotal += currVal;

                if (prevVal > 0) prevCount++;
                if (currVal > 0) currCount++;
              });

              const prevAvg =
                prevCount > 0 ? (prevTotal / prevCount).toFixed(1) : 0;
              const currAvg =
                currCount > 0 ? (currTotal / currCount).toFixed(1) : 0;

              let totalVariation = ((currTotal - prevTotal) * 100) / prevTotal;
              totalVariation = !isFinite(totalVariation) ? 0 : totalVariation;

              return (
                <tr key={`section-${i}`}>
                  <td className="table-dark">
                    {section.group_type
                      .toUpperCase()
                      .replace("_", " ")
                      .replace("P", "")
                      .replace("TOTALM", "M/EXP")
                      .replace("TOTALO", "OTHER")
                      .replace("PAS", "PASS")
                      .replace("OTHERS", "OTHER PASS")}
                  </td>
                  {selectedMonths.map((m, j) => (
                    <td key={`prev-${i}-${j}`}>{prevYearData[m] || 0}</td>
                  ))}
                  <td className="fw-bold bg-secondary text-white text-center">
                    {prevTotal}
                  </td>{" "}
                  <td className="fw-bold bg-secondary text-white text-center">
                    {prevAvg}
                  </td>
                  {selectedMonths.map((m, j) => (
                    <td key={`curr-${i}-${j}`}>{currYearData[m] || 0}</td>
                  ))}
                  <td className="fw-bold bg-secondary text-white text-center">
                    {currTotal}
                  </td>
                  <td className="fw-bold bg-secondary text-white text-center">
                    {currAvg}
                  </td>
                  {selectedMonths.map((m, j) => {
                    const prev = prevYearData[m] || 0;
                    const curr = currYearData[m] || 0;
                    let percentage = ((curr - prev) * 100) / prev;
                    percentage = !isFinite(percentage) ? 0 : percentage;

                    return (
                      <td key={`var-${i}-${j}`}>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            background:
                              percentage > 0
                                ? "rgba(88, 223, 61, 0.78)"
                                : "rgba(233, 75, 75, 0.9)",
                            color: "black",
                          }}
                        >
                          {percentage > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {percentage.toFixed(1)}
                        </div>
                      </td>
                    );
                  })}
                  <td className="fw-bold bg-dark text-center">
                    <div
                      className="m-1 text-center p-1"
                      style={{
                        borderRadius: "5px",
                        background:
                          totalVariation > 0
                            ? "rgba(88, 223, 61, 0.78)"
                            : "rgba(233, 75, 75, 0.9)",
                        color: "black",
                      }}
                    >
                      {totalVariation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {totalVariation.toFixed(1)}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>

          <tfoot className="table-dark text-center sticky-bottom">
            {(() => {
              const prevYearTotal = {};
              const currYearTotal = {};

              months.forEach((month) => {
                prevYearTotal[month] = 0;
                currYearTotal[month] = 0;
              });

              sections.forEach((section) => {
                const prevData = section.children[0]?.data || [];
                const currData = section.children[1]?.data || [];

                prevData.forEach(({ month_name, total_no }) => {
                  prevYearTotal[month_name] += Number(total_no) || 0;
                });

                currData.forEach(({ month_name, total_no }) => {
                  currYearTotal[month_name] += Number(total_no) || 0;
                });
              });

              let grandPrevTotal = 0;
              let grandCurrTotal = 0;

              selectedMonths.forEach((m) => {
                grandPrevTotal += prevYearTotal[m] || 0;
                grandCurrTotal += currYearTotal[m] || 0;
              });

              let totalVariation =
                ((grandCurrTotal - grandPrevTotal) * 100) / grandPrevTotal;
              totalVariation = !isFinite(totalVariation) ? 0 : totalVariation;

              return (
                <tr className="fw-bold text-center">
                  <td className="table-dark">TOTAL</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`tot-prev-${j}`}>{prevYearTotal[m]}</td>
                  ))}

                  <td>{grandPrevTotal}</td>
                  <td>{/* {grandCurrTotal} */}-</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`tot-curr-${j}`}>{currYearTotal[m]}</td>
                  ))}

                  <td>{grandCurrTotal}</td>
                  <td>{/* {grandCurrTotal} */}-</td>

                  {selectedMonths.map((m, j) => {
                    const prev = prevYearTotal[m] || 0;
                    const curr = currYearTotal[m] || 0;
                    let percentage = ((curr - prev) * 100) / prev;
                    percentage = !isFinite(percentage) ? 0 : percentage;

                    return (
                      <td key={`tot-var-${j}`}>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            background:
                              percentage > 0
                                ? "rgba(88, 223, 61, 0.78)"
                                : "rgba(233, 75, 75, 0.9)",
                            color: "black",
                          }}
                        >
                          {percentage > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {percentage.toFixed(1)}
                        </div>
                      </td>
                    );
                  })}

                  <td>
                    <div
                      className="m-1 text-center p-1"
                      style={{
                        borderRadius: "5px",
                        background:
                          totalVariation > 0
                            ? "rgba(88, 223, 61, 0.78)"
                            : "rgba(233, 75, 75, 0.9)",
                        color: "black",
                      }}
                    >
                      {totalVariation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {totalVariation.toFixed(1)}
                    </div>
                  </td>
                </tr>
              );
            })()}
          </tfoot>
          <tfoot className="table-dark text-center sticky-bottom">
            {(() => {
              const prevYearTotal = {};
              const currYearTotal = {};

              months.forEach((month) => {
                prevYearTotal[month] = 0;
                currYearTotal[month] = 0;
              });

              sections.forEach((section) => {
                const prevData = section.children[0]?.data || [];
                const currData = section.children[1]?.data || [];

                prevData.forEach(({ month_name, total_no }) => {
                  prevYearTotal[month_name] += Number(total_no) || 0;
                });

                currData.forEach(({ month_name, total_no }) => {
                  currYearTotal[month_name] += Number(total_no) || 0;
                });
              });
              let grandPrevTotal = 0;
              let grandCurrTotal = 0;

              selectedMonths.forEach((m) => {
                grandPrevTotal += prevYearTotal[m] || 0;
                grandCurrTotal += currYearTotal[m] || 0;
              });

              let totalVariation =
                ((grandCurrTotal - grandPrevTotal) * 100) / grandPrevTotal;
              totalVariation = !isFinite(totalVariation) ? 0 : totalVariation;

              return (
                <tr className="fw-bold text-center">
                  <td className="table-dark">AVG</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`tot-prev-${j}`}>
                      {(
                        prevYearTotal[m] /
                        getDaysInMonth(
                          Number(selectedFy.split("-")[0]) -
                            1 +
                            "_" +
                            String(Number(selectedFy.split("-")[1]) - 1).slice(
                              -2,
                            ),
                          m.toUpperCase(),
                        )
                      ).toFixed(2)}
                    </td>
                  ))}

                  <td>{/* {grandPrevTotal} */}-</td>
                  <td>{/* {grandPrevTotal} */}-</td>

                  {selectedMonths.map((m, j) => (
                    <td key={`tot-curr-${j}`}>
                      {(
                        currYearTotal[m] /
                        getDaysInMonth(
                          selectedFy.split("-")[0] +
                            "_" +
                            selectedFy.split("-")[1].slice(-2),
                          m.toUpperCase(),
                        )
                      ).toFixed(2)}
                    </td>
                  ))}

                  <td>{/* {grandCurrTotal} */}-</td>
                  <td>{/* {grandCurrTotal} */}-</td>

                  {selectedMonths.map((m, j) => {
                    const prev =
                      (
                        prevYearTotal[m] /
                        getDaysInMonth(
                          Number(selectedFy.split("-")[0]) -
                            1 +
                            "_" +
                            String(Number(selectedFy.split("-")[1]) - 1).slice(
                              -2,
                            ),
                          m.toUpperCase(),
                        )
                      ).toFixed(2) || 0;
                    const curr =
                      (
                        currYearTotal[m] /
                        getDaysInMonth(
                          selectedFy.split("-")[0] +
                            "_" +
                            selectedFy.split("-")[1].slice(-2),
                          m.toUpperCase(),
                        )
                      ).toFixed(2) || 0;
                    let percentage = ((curr - prev) * 100) / prev;
                    percentage = !isFinite(percentage) ? 0 : percentage;

                    return (
                      <td key={`tot-var-${j}`}>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            background:
                              percentage > 0
                                ? "rgba(88, 223, 61, 0.78)"
                                : "rgba(233, 75, 75, 0.9)",
                            color: "black",
                          }}
                        >
                          {percentage > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {percentage.toFixed(1)}
                        </div>
                      </td>
                    );
                  })}

                  <td>
                    {/* <div
                      className="m-1 text-center p-1"
                      style={{
                        borderRadius: "5px",
                        background:
                          totalVariation > 0
                            ? "rgba(88, 223, 61, 0.78)"
                            : "rgba(233, 75, 75, 0.9)",
                        color: "black",
                      }}
                    >
                      {totalVariation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {totalVariation.toFixed(1)}
                    </div> */}
                    -
                  </td>
                </tr>
              );
            })()}
          </tfoot>
        </table>
      </div>

      <DownloadExcel
        tableRef={tableRef}
        fileName={`Punctuality Month Wise Comparison - ${selectedFy}`}
      />
    </div>
  );
};

export default PuncMonthlyReport;
